import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const LiveActivityFeed = () => {
  const [activities, setActivities] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const allActivities = [
    { id: 1, user: 'Sarah M.', action: 'analyzed', stock: 'TSLA', time: 'Just now', avatar: 'SM', color: 'from-gray-700 to-gray-800' },
    { id: 2, user: 'John D.', action: 'received alert for', stock: 'AAPL', time: '1 min ago', avatar: 'JD', color: 'from-gray-600 to-gray-700' },
    { id: 3, user: 'Mike R.', action: 'tracked portfolio', stock: '$45K', time: '2 min ago', avatar: 'MR', color: 'from-gray-700 to-gray-800' },
    { id: 4, user: 'Lisa W.', action: 'screened', stock: 'NVDA', time: '4 min ago', avatar: 'LW', color: 'from-gray-600 to-gray-700' },
    { id: 5, user: 'David K.', action: 'compared', stock: 'MSFT vs GOOGL', time: '6 min ago', avatar: 'DK', color: 'from-gray-700 to-gray-800' },
    { id: 6, user: 'Emma S.', action: 'analyzed', stock: 'META', time: '8 min ago', avatar: 'ES', color: 'from-gray-600 to-gray-700' },
    { id: 7, user: 'Tom B.', action: 'set alert for', stock: 'AMZN', time: '10 min ago', avatar: 'TB', color: 'from-gray-700 to-gray-800' },
    { id: 8, user: 'Anna K.', action: 'analyzed', stock: 'NFLX', time: '12 min ago', avatar: 'AK', color: 'from-gray-600 to-gray-700' },
  ];

  useEffect(() => {
    // Initialize with first 5 activities
    setActivities(allActivities.slice(0, 5));

    // Cycle through activities - change active card every 2 seconds (snappier)
    const interval = setInterval(() => {
      setActiveIndex(prev => {
        const next = (prev + 1) % 5;
        return next;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="live-activity" className="bg-gradient-to-b from-gray-50 to-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Header */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#222425] mb-6 tracking-tight">
            Join Investors Using TraderBro
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto font-light">
            Real-time activity from our community
          </p>
        </div>

        {/* Rolling Wave Activity Feed - Vertical List */}
        <div className="max-w-3xl mx-auto space-y-3">
          {activities.map((activity, index) => {
            const isActive = index === activeIndex;

            return (
              <div
                key={activity.id}
                className="bg-white rounded-2xl transition-all duration-500 ease-out overflow-hidden relative"
                style={{
                  height: isActive ? '100px' : '72px',
                  opacity: isActive ? 1 : 0.7,
                  transform: isActive ? 'scale(1.01)' : 'scale(0.99)',
                  border: isActive ? '1px solid #d1d5db' : '1px solid #e5e7eb',
                  transformOrigin: 'center center',
                  boxShadow: isActive ? '0 8px 16px -4px rgba(0, 0, 0, 0.08)' : '0 1px 3px rgba(0, 0, 0, 0.05)'
                }}
              >
                {/* Subtle accent bar on left side when active */}
                <div
                  className="absolute left-0 top-0 bottom-0 bg-[#00DA76] transition-all duration-500"
                  style={{
                    width: isActive ? '3px' : '0px',
                    opacity: isActive ? 0.5 : 0
                  }}
                ></div>
                {/* Card Content */}
                <div className="h-full flex items-center gap-4 px-6">
                  {/* Avatar with dynamic gradient */}
                  <div
                    className={`flex-shrink-0 bg-gradient-to-br ${activity.color} rounded-full flex items-center justify-center text-white font-bold shadow-sm transition-all duration-700`}
                    style={{
                      width: isActive ? '56px' : '44px',
                      height: isActive ? '56px' : '44px',
                      fontSize: isActive ? '18px' : '14px'
                    }}
                  >
                    {activity.avatar}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <p
                      className="text-[#222425] font-medium transition-all duration-700"
                      style={{
                        fontSize: isActive ? '17px' : '15px',
                        lineHeight: '1.4'
                      }}
                    >
                      <span className="font-semibold">{activity.user}</span>
                      {' '}<span className="text-gray-600 font-normal">{activity.action}</span>{' '}
                      <span className="text-[#222425] font-semibold">{activity.stock}</span>
                    </p>
                    <div
                      className="flex items-center gap-2 transition-all duration-700"
                      style={{
                        marginTop: isActive ? '6px' : '4px',
                        opacity: isActive ? 1 : 0.7
                      }}
                    >
                      <span className="relative flex h-2 w-2">
                        {isActive && (
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gray-600 opacity-40"></span>
                        )}
                        <span className={`relative inline-flex rounded-full h-2 w-2 ${isActive ? 'bg-gray-600' : 'bg-gray-400'}`}></span>
                      </span>
                      <p className="text-xs text-gray-500 font-medium">{activity.time}</p>
                    </div>
                  </div>

                  {/* Icon - only visible on active card */}
                  <div
                    className="flex-shrink-0 transition-all duration-500"
                    style={{
                      opacity: isActive ? 1 : 0,
                      transform: isActive ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-90deg)'
                    }}
                  >
                    <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-8 md:mt-10">
          <p className="text-gray-600 mb-6 text-base md:text-lg font-light">
            Be part of the next generation of investors
          </p>
          <Link
            to="/login"
            onClick={() => {
              if (typeof gtag !== 'undefined') {
                gtag('event', 'click', {
                  event_category: 'dashboard_cta',
                  event_label: 'activity_feed_cta',
                  value: 1
                });
              }
            }}
            className="group inline-flex items-center gap-2 bg-[#222425] hover:bg-[#2a2b2c] text-white font-semibold px-8 py-4 rounded-xl transition-all duration-300 hover:shadow-lg hover:scale-105"
          >
            <span>Sign In to Dashboard</span>
            <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default LiveActivityFeed;
